import React from "react";

import TotalSunPresenter from "./TotalSunPresenter";

export default class extends React.Component {

  render() {
    return <TotalSunPresenter />;
  }
}
